import React from "react";
import tw from "twin.macro";
import styled from "styled-components";
import {Container as ContainerBase } from "components/misc/Layouts.js"
import logo from "../../images/lra.svg";

// const Container = tw(ContainerBase)`bg-primary-900 text-white -mx-8 -mb-8 relative fixed bottom-0`
const Container = tw(ContainerBase)`bg-primary-900 text-white -mx-8 -mb-8 relative`
const Content = tw.div`max-w-screen-xl mx-auto py-6`;

const Row = tw.div`flex items-center justify-center flex-col`

const LogoContainer = tw.div`flex items-center justify-center md:justify-start`;
const LogoImg = tw.img`w-8`;
const LogoText = tw.h5`ml-2 text-2xl font-black tracking-wider`;

const LinksContainer = tw.div`mt-4 font-medium flex flex-wrap justify-center items-center flex-col sm:flex-row`
const Link = tw.a`border-b-2 border-transparent hocus:text-gray-300 hocus:border-gray-300 pb-1 transition duration-300 mt-2 mx-4`;

const SocialLinksContainer = tw.div`mt-6`;
const SocialLink = styled.a`
  ${tw`cursor-pointer inline-block text-gray-100 hover:text-gray-500 transition duration-300 mx-4`}
  svg {
    ${tw`w-5 h-5`}
  }
`;

const CopyrightText = tw.p`text-center m-4 font-medium text-sm text-white`

export default () => {
  return (
    <Container>
      <Content>
        <Row>
          {/* <LogoContainer>
            <LogoImg src={logo} />
            <LogoText>LightRainAir</LogoText>
          </LogoContainer> */}
          <LinksContainer>
            <Link href="/disclaimer">Disclaimer</Link>
            <Link href="https://zegleedmcpswaxynxnta.supabase.co/storage/v1/object/public/assets/05072024___Privacy_Policy_(Shincheonji)___Final.pdf">Privacy Policy</Link>
            <Link href="https://zegleedmcpswaxynxnta.supabase.co/storage/v1/object/public/assets/05072024___Terms_of_Use_(Shincheonji)___Final.pdf">Terms of Use</Link>
          </LinksContainer>
          <CopyrightText>
            &copy; Copyright 2024, Shincheonji. All Rights Reserved.
          </CopyrightText>
        </Row>
      </Content>
    </Container>
  );
};
